module.exports = __webpack_public_path__ + "static/media/tetrapackQuestion.4b724c13.png";